import { gql } from "@apollo/client";
import { NOTIFICACAO_FIELDS } from "./fragments";

export const MINHAS_NOTIFICACOES = gql`
  ${NOTIFICACAO_FIELDS}
  query MinhasNotificacoes($pagination: PaginationInput, $apenasNaoLidas: Boolean) {
    minhasNotificacoes(pagination: $pagination, apenasNaoLidas: $apenasNaoLidas) {
      items {
        ...NotificacaoFields
      }
      total
      page
      limit
      totalPages
      hasMore
    }
  }
`;

export const CONTADOR_NOTIFICACOES = gql`
  query ContadorNotificacoes {
    contadorNotificacoes {
      total
      naoLidas
    }
  }
`;
